import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

import { COLORS } from "../utils/colors";

export const MainButton = ({
  onClickAction,
  text,
  color,
  textColor,
  hoverColor,
  textHoverColor,
  borderColor,
  fontFamily,
  fontSize,
  fontWeight,
  disabled,
  shadowColor,
  children,
  textAlignment,
  width,
  iconPosition,
}) => {
  const ColorButton = styled(Button)(() => ({
    position: "relative",
    alignItems: "center",
    justifyContent: textAlignment || "center",
    color: textColor || COLORS.black,
    backgroundColor: color || COLORS.grey2,
    fontFamily: fontFamily || "AuthenticSans90",
    fontSize: fontSize || "14px",
    fontWeight: fontWeight || "light",
    borderRadius: "6px",
    padding: "5px 25px",
    textTransform: "none",
    width: width || "-webkit-fill-available",
    height: "35px",
    boxShadow: borderColor ? `inset 0px 0px 0px 1px ${borderColor}` : "none",
    gap: "5px",

    "&:hover": {
      backgroundColor: hoverColor || "transparent",
      color: textHoverColor || COLORS.black,
      boxShadow: shadowColor
        ? `inset 0px 0px 2px 1px ${shadowColor}`
        : "inset 0px 0px 2px 1px #000000",
    },
  }));

  return (
    <ColorButton
      disabled={disabled}
      variant="contained"
      onClick={onClickAction}
    >
      {(iconPosition === "left" || !iconPosition) && children}
      {text}
      {iconPosition === "right" && children}
    </ColorButton>
  );
};
